import { HTTP } from '@/axios_api/http-common' 

const state = {
  departments: []
}

interface IState {
    departments: Array<IDepartments>
}

interface IDepartments {
    id: number,
    name: string,
    operationUnits: Array<any>
}

const mutations = {
    setDepartments (state: IState, departments: Array<IDepartments>) {
        state.departments = departments
    },
    addDepartment(state: IState, department: IDepartments){
        state.departments.push(department)
    },
    addTeam(state:IState,team:any){
        let indexToUpdate = state.departments.findIndex(d=> d.id==team.departmentId)
        if(indexToUpdate>-1)state.departments[indexToUpdate].operationUnits.push(team)
    },
    updateDepartment(state: IState, department: IDepartments){
        var _exIndex = -1;
        for (let index = 0; index < state.departments.length; index++) {
            if(state.departments[index].id == department.id) {
               _exIndex = index;
                break;
            } 
       }
       if(_exIndex > -1)
           state.departments.splice(_exIndex,1,{...department, id: (department.id.toString() as any)});
    },
    updateDepartmentBudget(state: IState, payload: any) {
        var _exIndex = -1;
        for (let index = 0; index < state.departments.length; index++) {
            if(state.departments[index].id == payload.id) {
               _exIndex = index;
                break;
            } 
       }
       if(_exIndex > -1)
           state.departments.splice(_exIndex,1,{...state.departments[_exIndex], id: (payload.id.toString() as any)});
    },
    updateTeam(state:IState,team:any){
        let departmentIndexToUpdate = state.departments.findIndex(d=> d.id==team.departmentId)
        let teamIndexToUpdate = state.departments[departmentIndexToUpdate].operationUnits.findIndex(t=>t.id==team.id)
        state.departments[departmentIndexToUpdate].operationUnits.splice(teamIndexToUpdate,1,team)
    },
    deleteDepartment(state: IState, deletedIds: string[]){
        state.departments = state.departments.filter(dep => !deletedIds.includes(dep.id.toString()));
    },
    deleteTeam(state:IState,data:any){
        let departmentIndexToUpdate = state.departments.findIndex(d=> d.id==data.departmentId)
        let contractIndexToUpdate = state.departments[departmentIndexToUpdate].operationUnits.findIndex(t=>t.id==data.id)
        state.departments[departmentIndexToUpdate].operationUnits.splice(contractIndexToUpdate,1)
    },
}

const getters = {
    getDepartmentOptions:(state: IState)=>{
        let departmentOptions: Array<any>=[]
        state.departments.forEach((department: any)=>{
            departmentOptions.push({text:department.name,value:department.id})
        })
        return departmentOptions
    },

    getAllDepartments: (state: IState) => {
        return state.departments
    },

    getAllTeams:(state:IState)=>{
        const teamsToReturn = [] as Array<any>
        state.departments.forEach((d:any) => {
            teamsToReturn.push(...d.operationUnits)
        })
        return teamsToReturn
    },

    fillteredDepartments:(state: IState) =>(filter: string)=> {
        if(!state.departments)return [];
        return state.departments.filter((department: any) => {
            return department.name.toLowerCase().match(filter.toLowerCase())
        });
    },

    getDepartmentById:(state: IState)=>(id: number)=>{
        let department = null
        for (let index = 0; index < state.departments.length; index++) {
             if(state.departments[index].id == id) {
                 department = state.departments[index];
                 break;
             } 
        }
        return department
    }
}

const actions = {
    getDepartments ({ commit } : { commit: any}) {       
        return new Promise((resolve, reject) => {
            HTTP.get('departments')
            .then((response: any) => {
                commit('setDepartments', response.data.data)         
                resolve(response)                    
            })
            .catch((error: any) => {
                reject(error)
            })
        })
    },
    createDepartment ({ commit } : { commit: any }, department_object: any) {
        
        return new Promise((resolve, reject) => {
            HTTP.post('departments/create', department_object)
            .then((response: any) => {
                commit('addDepartment',response.data.data) 
                resolve(response)
            })
            .catch((error: any) => {
              reject(error)
            })
        })
    },
    updateDepartment ({ commit }: { commit: any }, department: any) {
        return new Promise((resolve, reject) => {
            HTTP.put('departments/update/' + department.id, department )
            .then((response: any) => {
                commit('updateDepartment', department)
                resolve(response)
            })
            .catch((error: any) => {
                reject(error)
            });
        })        
    },
    updateDepartmentBudget ({ commit }: { commit: any }, payload: any) {
        return new Promise((resolve, reject) => {
            HTTP.put('departments/budget/update', payload )
            .then((response: any) => {
                commit('updateDepartmentBudget', payload)
                resolve(response)
            })
            .catch((error: any) => {
                reject(error)
            });
        })        
    },
    deleteDepartment ({ commit } : { commit : any }, departmentIds: any) {
        return new Promise((resolve, reject) => {
            HTTP.delete('departments/delete', {data: departmentIds})
            .then((response: any) => {
                
                commit('deleteDepartment', departmentIds)

                resolve(response)
            })
            .catch((error: any) => {
                reject(error)
            })
        })      
    },
    createTeam({commit}:{commit:any},operation:any){
        return new Promise((resolve,reject)=>{
            HTTP.post('departments/operation-unit/create',operation).then((response:any) => {
                commit('addTeam',response.data.data) 
                resolve(response);
            })
        })
    },
    updateTeam({commit}:{commit:any},operation:any){
        return new Promise((resolve,reject)=>{
            HTTP.put('departments/operation-unit/update/'+operation.id,operation)
            .then((response:any) => {
                commit('updateTeam', response.data.data)
                resolve(response)
            })
            .catch((error:any)=>{
                reject(error)
            })
        })
    },
    deleteTeam({ commit } : {commit: any}, data: any) {
        return new Promise((resolve, reject) => {
            HTTP.delete('departments/operation-unit/delete/' + data.id)
                .then((response: any) => {
                    commit('deleteTeam', data)
                    resolve(response)
                })
                .catch((error: any) => {
                    reject(error)
                })
        })
    }, 
}

const departmentModule = {
  namespaced:true,
  state,
  mutations,
  getters,
  actions
}

export default departmentModule;
